import { takeLatest } from "redux-saga/effects";
import { 
    GetLifestyleEntries, 
    AddLifestyleEntry, 
    GetDietRecommendations,
    DeleteLifestyleEntry,
    GetLifestyleConfig
} from "../../StateManagement/Reducers/LifestyleState";
import { 
    GetLifestyleEntriesWorker, 
    AddLifestyleEntryWorker, 
    GetDietRecommendationsWorker,
    DeleteLifestyleEntryWorker,
    GetLifestyleConfigWorker
} from "./LifestyleSagaWorkers";

export function* GetLifestyleEntriesWatcher() {
    yield takeLatest(GetLifestyleEntries.type, GetLifestyleEntriesWorker);
}

export function* AddLifestyleEntryWatcher() {
    yield takeLatest(AddLifestyleEntry.type, AddLifestyleEntryWorker);
}

export function* GetDietRecommendationsWatcher() {
    yield takeLatest(GetDietRecommendations.type, GetDietRecommendationsWorker);
}

export function* DeleteLifestyleEntryWatcher() {
    yield takeLatest(DeleteLifestyleEntry.type, DeleteLifestyleEntryWorker);
}

export function* GetLifestyleConfigWatcher() {
    yield takeLatest(GetLifestyleConfig.type, GetLifestyleConfigWorker);
}
